import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { hasPermission } from "../../utils/roleUtils";

const RequirePermission = ({ permissionName, children, fallback = null }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading || !user) {
    return fallback;
  }

  if (!hasPermission(user, permissionName)) {
    return fallback;
  }

  return children;
};

export default RequirePermission;
